import { apiClient } from './apiClient';

const base = '/api/payment';

export const paymentService = {
  // Create Razorpay order
  createRazorpayOrder: orderData => apiClient.post(`${base}/razorpay/order`, orderData),

  // Verify payment
  verifyPayment: paymentData => apiClient.post(`${base}/verify`, paymentData),

  // Get payment history
  getHistory: (params = {}) => {
    const queryParams = new URLSearchParams(params);
    return apiClient.get(`${base}/history?${queryParams}`);
  },

  // Get payment details
  getPayment: paymentId => apiClient.get(`${base}/${paymentId}`),

  // Refund payment
  refundPayment: (paymentId, refundData) =>
    apiClient.post(`${base}/${paymentId}/refund`, refundData),
};

export default paymentService;
